export default {
  EN_US: 'en-US',
  HI_IN: 'hi-IN',
};
